import { Pipe, PipeTransform } from '@angular/core';
import { IMagazineArticle } from '../models/magazine-result';

@Pipe({
    name: 'magazineArticleFilter',
    pure: false
})
export class MagazineArticlePipe implements PipeTransform {
    transform(articles: any[], filter: IMagazineArticle): IMagazineArticle[] {
        if (!articles || !filter) {
            return articles;
        }

        return articles.filter(
            article =>
                article.isPromoted === filter.isPromoted &&
                (!filter.extraInfo ||
                    article.extraInfo.indexOf(filter.extraInfo) !== -1) &&
                (!filter.title || article.title.indexOf(filter.title) !== -1) &&
                (!filter.subtitle ||
                    article.subtitle.indexOf(filter.subtitle) !== -1) &&
                (!filter.text || article.text.indexOf(filter.text) !== -1)
        );
    }
}
